import SectionCard from '@Guidelines/Component/SectionCard';
import type SubjectTypeDefinitionFormData from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import * as React from 'react';
import { useSelector } from '@verclam/synapse';
import { Checkbox, Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly formData: SubjectTypeDefinitionFormData;
	readonly onChange: (
		update: (formData: SubjectTypeDefinitionFormData) => SubjectTypeDefinitionFormData,
	) => void;
	readonly isReadOnly: boolean;
};

/** Who may add members to a dossier of this type, and how its participants are informed. */
const SharingSection: React.FC<Props> = ({ formData, onChange, isReadOnly }) => {
	const informationModes = useSelector((state) => state.subjectTypeDefinitionsStore.informationModes);
	const informationModeMessage = formData.getInformationModeServerMessage();

	const handleMembersCanShareChange = React.useCallback(
		(checked: boolean) => {
			onChange((current) => current.setMembersCanShare(checked));
		},
		[onChange],
	);

	const handleInformationModeChange = React.useCallback(
		(value: string | null) => {
			if (value !== null) {
				onChange((current) => current.setInformationMode(value));
			}
		},
		[onChange],
	);

	return (
		<SectionCard title="Partage et information">
			<Checkbox
				name="membersCanShare"
				label="Les membres peuvent ajouter d'autres membres"
				checked={formData.membersCanShare}
				disabled={isReadOnly}
				onChange={handleMembersCanShareChange}
			/>
			<Dropdown
				name="informationMode"
				label="Information des participants"
				options={informationModes ?? []}
				optionLabel="label"
				optionValue="value"
				value={formData.informationMode}
				disabled={isReadOnly}
				onChange={handleInformationModeChange}
				errorMessage={informationModeMessage ?? undefined}
				isFormFieldValid={informationModeMessage === null}
			/>
		</SectionCard>
	);
};

export default SharingSection;
